<section class="uscb-flex">
    <div class="uscb-layout-column">
        <h1 class="uscb-flex :white uscb-regular">{{ displayTitle() }}</h1>
        <hr role="presentation" class="uscb-hr-flex uscb-bg-primary uscb-margin-T-10">
        <h3>Trying to reach your survey?</h3>
        <ul class="not-found-options">
            <li>To respond to the Special Census survey, please click <a href="/specialcensus">here</a></li>
            <li>For all other surveys, please click <a href="/portal">here</a></li>
        </ul>

        @if (showAdditionalInfo()) {
        <p class="uscb-sub-heading-1 not-found">For additional survey information, please visit our <a href="https://www.census.gov/programs-surveys.html">Surveys &amp; Programs</a> page on Census.gov</p>
        }
    </div>
</section>